<template>
  <div class="main" v-loading="loading">
    <el-scrollbar style="height:100%;" ref="scrollbar" wrap-class="scrollbar-wrapper">
      <div class="header clearfix">
        <div v-if="companyStatus.logoPath" class="logo"><img :src="companyStatus.logoPath" alt="" srcset="" @error.once="companyStatus.logoPath = null"></div>
        <div v-else :class="['logo2',{'aliasLineHeight': aliasLineHeight}]" :style="'background:'+ backgroundColor">{{setLineHeight(companyStatus.alias)}}</div>

        <div class="hright">
          <!-- 添加种子企业 -->
          <div class="zd-zhongzhi" @click="updateTrans(componentInfo.trans)" v-if="yczz">
            <img src="@/assets/zhong_active.png" v-if="componentInfo.trans" alt="">
            <img src="@/assets/zhong.png" v-else alt="">
          </div>

          <h2 style="width: 100%;">
            <div>
              <div class="sub-title textOverflow cls001 tags" style="max-width: 421px;float: left;font-size: 16px;    display: flex;align-items: center;" :title="companyStatus.companyName"><span
                  class="copyName" @click="copyName(companyStatus.companyName)">{{ companyStatus.companyName || '--' }}</span> <el-tag style="margin-left:8px" class="box box1" size="small"
                  type="theme" v-if="companyStatus.regStatus">{{companyStatus.regStatus}}</el-tag> </div>

            </div>

            <companyRefresh ref="companyRefresh" :companyName="companyStatus.companyName" :hid="companyStatus.hid" :disabled="false" @update="getData" @setPcinfo="setPcinfo" />
          </h2>
          <div class="tags" style="min-height: 24px;margin-top:10px">
            <!-- 曾用名 -->
            <el-tooltip popper-class="tpss" class="item popperClass" effect="light" placement="bottom-start" v-if="historyNameList">
              <el-button>曾用名</el-button>
              <div slot="content" class="company-list">
                <p v-for="(item,index) in this.historyNameList" :key="index">{{item}}</p>
              </div>
            </el-tooltip>
            <el-tag class="new-box1" style="margin-right:8px" size="small" type="warning" v-if="companyStatus.hasDouyinShop == 1">抖音店铺</el-tag>
            <el-tag class="new-box1 hasBlue" style="margin-right:8px" size="small" type="warning" v-if="companyStatus.hasLanVipCompany == 1">蓝V企业</el-tag>
            <el-tag class="box new-box1" size="small" type="theme" v-if="(companyStatus || {}).contactCount">联系方式：{{companyStatus.contactCount.contactCount || 0}}</el-tag>
            <el-tag class="box new-box1" size="small" type="theme" v-for="(tag,i) in companyTags" :key="i">{{tag}}</el-tag>
            <el-tag class="box new-box1" size="small" type="theme" v-if="cxtList.length>0">诚信通会员 ({{cxtList[0].tpServiceYear}}年)</el-tag>
          </div>
          <el-row>
            <el-col :span="8">
              <span class="span01">企业法人：</span> <span class="span02">{{companyStatus.legalPersonName || '--'}}</span>
            </el-col>
            <el-col :span="8">
              <span class="span01">成立日期：</span>
              <span class="span02" v-if="companyStatus.establishTime">{{companyStatus.establishTime  | formatTime }}</span>
              <span class="span02" v-else>{{companyStatus.estiblishTime | formatTime}}</span>
            </el-col>
            <el-col :span="8">
              <span class="span01">注册资本：</span>
              <span class="span02" v-if="companyStatus.regCapital">{{Global.formatAmount(companyStatus.regCapital)}}</span>
              <span class="span02" v-else>{{Global.formatAmount(regCapital)}}</span>
            </el-col>
          </el-row>
          <el-row class="mt-10">
            <el-col :span="8">
              <span class="span01">企业规模：</span> <span class="span02">{{staffSize}}</span>
            </el-col>
            <el-col :span="8">
              <span class="span01">参保人数：</span>
              <span class="span02">{{companyStatus.participants || '--' }}</span>
            </el-col>
            <el-col :span="8">
              <span class="span01">年营业额：</span>
              <span class="span02">{{ info.staffNumRange||'--' }}</span>
            </el-col>
          </el-row>
          <el-row class="mt-10">
            <el-col class="isurl">
              <span class="span01">企业网址：</span>
              <a v-if="isUrls.status === 'icon'" :href="isUrls.string" target="_blank">
                <el-tooltip popper-class="tpss" class="item" effect="light" placement="bottom">
                  <span><img src="@/assets/gbIcon/certificate_icon.svg" style="margin-top:-2px"></span>
                  <div slot="content" class="company-list">
                    <p>{{yearTime}}年工商年报</p>
                  </div>
                </el-tooltip>
                {{isUrls.string}}
              </a>
              <a v-else-if="isUrls.status === 'string'" :href="isUrls.string" target="_blank">{{isUrls.string}}</a>
              <span class="span02" v-else-if="isUrls.status==='array'">
                <div v-show="!showMoreA"><a style="display:inline-block" :href="isUrls.array[0]" target="_blank">{{isUrls.array[0]}}</a>
                  <span class="more" @click="showMore">更多></span>
                </div>
                <div style="display:flex" v-show="showMoreA">
                  <div>
                    <a v-for="(url,i) in isUrls.array" :key="i" :href="url" target="_blank">{{url}}</a>
                  </div>
                  <span class="more" @click="showMoreA=false">收起></span>
                </div>

              </span>
              <span class="span02" v-else>--</span>
            </el-col>
          </el-row>
          <el-row class="mt-10">
            <el-col>
              <span class="span01">所属行业：</span>
              <span class="span02">{{companyIndustry}}</span>
            </el-col>
          </el-row>
          <el-row class="mt-10">
            <el-col class="address">
              <span class="span01">注册地址：</span>
              <!-- addressTT  -->
              <span class="span02" v-html="companyStatus.regAddress || companyStatus.regLocation ||'--'"></span>
            </el-col>
          </el-row>
          <el-row class="mt-10">
            <el-col class="address">
              <span class="span01">经营地址：</span>
              <!-- addressTT  -->
              <span class="span02" v-html="companyStatus.address ||'--'"></span>
            </el-col>
          </el-row>
          <el-row v-if="componentInfo.companyNameEn" class="mt-10">
            <el-col class="address">
              <span class="span01">英文名称：</span>
              <!-- addressTT  -->
              <span v-if="!componentInfo.aliCompanyNameUrl" class="span02" v-html="componentInfo.companyNameEn"></span>
              <span v-else class="span02">
                <el-link style="display: inline" :href="componentInfo.aliCompanyNameUrl" target="_blank" :underline="false">{{componentInfo.companyNameEn}}</el-link>
              </span>
            </el-col>
          </el-row>
          <el-row v-if="componentInfo.gjhRecord" class="mt-10">
            <el-col class="address">
              <span class="span01">广交会参会历史：</span>
              <!-- addressTT  -->
              <span class="span02" v-html="componentInfo.gjhRecord"></span>
            </el-col>
          </el-row>
          <!-- <div class="tags mt-15 ">
            <el-tag class="mr-5 mb-b" v-for="(item,i) in tags" :key="i" :type="item.type" effect="plain" size="small">
              {{ item.label }}
            </el-tag>
          </div> -->
        </div>
      </div>
      <div class="enterpriseBody mt-10" ref="enterpriseBody">
        <div :class="['tabfixed',{'fixed':fixed}]" ref="tabfixed">
          <el-tabs :class="['cls-tabs-navs',{'newPosition':tabFlag}]" v-model="activeName" @tab-click="handleClick">
            <el-tab-pane v-for="(item, index) in tabs" :key="index" :label="item.label+' '+computedNum1(item.num)" :name="String(index+1)" :disabled="!item.num" />
            <!-- <el-tab-pane :label="'新闻动态 '+computedNum1(tabNewNum)" name="10" :key="10" :disabled="!tabNewNum" /> -->
          </el-tabs>

          <div class="componentTags">
            <el-button class="mr-10 mb-10" v-for="(item,i) in componentTitles" :key="i" :type="item.type" size="mini" :disabled="item.num?false:true" @click="tagsHandle(i)">
              {{item.label+computedNum2(item.num)}}
            </el-button>
          </div>
        </div>
      </div>

      <div class="tab">
        <transition name="el-fade-in-linear">
          <basic-msg ref="basicMsg" v-if="activeName == 1" :tabsInfo="tabs[activeName-1].children" :activeInfo="activeInfo" @setTitle="setTitles" @pageTurn="companyDetailBatchV2" />
        </transition>
        <transition name="el-fade-in-linear">
          <development v-if="activeName == 2" :hid="companyStatus.hid" :tabsInfo="tabs[activeName-1].children" :activeInfo="activeInfo" @setTitle="setTitles" @pageTurn="companyDetailBatchV2" />
        </transition>

        <transition name="el-fade-in-linear">
          <manage v-if="activeName == 3" :tabsInfo="tabs[activeName-1].children" :activeInfo="activeInfo" @setTitle="setTitles" @pageTurn="companyDetailBatchV2" />
        </transition>

        <transition name="el-fade-in-linear">
          <business-risk v-if="activeName == 4" :tabsInfo="tabs[activeName-1].children" :activeInfo="activeInfo" @setTitle="setTitles" @pageTurn="companyDetailBatchV2" />
        </transition>

        <transition name="el-fade-in-linear">
          <legal-risk v-if="activeName == 5" :tabsInfo="tabs[activeName-1].children" :activeInfo="activeInfo" @setTitle="setTitles" @pageTurn="companyDetailBatchV2" />
        </transition>

        <transition name="el-fade-in-linear">
          <property v-if="activeName == 6" :tabsInfo="tabs[activeName-1].children" :activeInfo="activeInfo" @setTitle="setTitles" @pageTurn="companyDetailBatchV2" />
        </transition>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
import { parseTime, sortKey } from '@/base/global'
import basicMsg from '../components/basicMsg.vue'
import development from '../components/development.vue'
import advertising from '../components/advertising.vue'
import property from '../components/property.vue'
import news from '../components/news.vue'
import manage from '../components/manage.vue'
import bidding from '../components/bidding.vue'
import legalRisk from '../components/legalRisk.vue'
import businessRisk from '../components/businessRisk.vue'
import intellectual from '../components/intellectual.vue'
import relation from '../components/relation.vue'
import companyRefresh from '../components/companyRefresh'
import businessBox from '../components/businessBox'
import recruitmentMsg from '../components/recruitmentMsg'

import { companyDetailBatchV2, getByPageBatchV2, companyBasicCountV2, companyCategoryCountV2, getNews, visitCompany, getByPageV2 } from '../api/newClueApi'
import { transactionAdd, transactionDel } from '../api/index.js'
import { X_HIDE, X_tabCardNum, X_smallCardNum, X_isQw } from '@/utils/iframeUtils'
export default {
  name: 'EnterpriseNew',
  components: {
    basicMsg,
    development,
    advertising,
    property,
    news,
    manage,
    bidding,
    legalRisk,
    businessRisk,
    // company,
    intellectual,
    relation,
    companyRefresh,
    businessBox,
    recruitmentMsg
  },
  data() {
    return {

      yczz: false, //隐藏种子按钮
      componentInfo: {}, // 企业信息
      showMoreA: false,
      tab: 1,
      loading: false,
      info: {},
      activeInfo: [],
      activeInfoMap: {},
      activeName: '1',
      flexBarHeight: 0,
      aliasLineHeight: false,
      mapIndex: {
        1: 0,
        2: 1,
        3: 5,
        4: 2,
        6: 4,
        7: 3
      },
      tabs: [
        { label: '基本信息', num: 0, children: [], activeInfo: [] },
        { label: '企业发展', num: 0, children: [], activeInfo: [] },
        { label: '经营信息', num: 0, children: [], activeInfo: [] },
        { label: '经营风险', num: 0, children: [], activeInfo: [] },
        { label: '司法风险', num: 0, children: [], activeInfo: [] },
        { label: '知识产权', num: 0, children: [], activeInfo: [] }
      ],
      tabsOld: [
        { label: '基本信息', num: 0, children: [], activeInfo: [] },
        { label: '企业发展', num: 0, children: [], activeInfo: [] },
        { label: '招聘信息', num: 0, children: [], activeInfo: [] },
        // { label: '广告推广', num: 0, },
        { label: '知识产权', num: 0, children: [], activeInfo: [] },
        { label: '推广信息', num: 0, children: [], activeInfo: [] },
        { label: '经营信息', num: 0, children: [], activeInfo: [] },
        { label: '招标投标', num: 0, children: [], activeInfo: [] },
        { label: '司法风险', num: 0, children: [], activeInfo: [] },
        { label: '经营风险', num: 0, children: [], activeInfo: [] },
        // { label: '新闻动态', num: 0, },
      ],
      tabNewNum: 0,
      tabNewsActive: 9,
      componentTitles: [],
      componentTitles1: [], // 基本信息
      fixed: false,
      scrollbar: '',
      btnIndex: 0,
      tabsNum: 0, // 基本信息
      isClick: false,
      bgColor: ['#7DB3D9', '#84CAB0', '#8CA3CD', '#BC9EDD'],
      cxtList: [],
      historyNameList: [], //曾用名
      yearTime: '',//标识网站对应的年份
      tabFlag: false //是否是招聘跳过来的
    }
  },
  props: {
    companyStatus: {
      type: Object,
      default: () => { return {} }
    }
  },
  provide() {
    return {
      $companyStatus: this.companyStatus
    }
  },
  watch: {
    activeName: {
      // immediate: true,
      handler(val) {
        this.$nextTick(() => {
          // 赋值fixed框
          setTimeout(() => {
            this.$refs.enterpriseBody.style.height = this.$refs.tabfixed.offsetHeight + 'px'
            this.$refs.scrollbar.$el.querySelector('.el-scrollbar__wrap').scrollTop = this.$refs.enterpriseBody.offsetTop
          }, 0)
        })
      }
    },
    tabsNum1: {
      immediate: true,
      handler(val) { // this.componentTitles1[0].num === 企业简介数量  this.componentTitles1[8].num === 相似企业数量
        this.tabs[0].num = val || 0
      }
    },
    'tabs.0.num': {
      handler(val) {
        this.$nextTick(() => {
          // 赋值fixed框
          setTimeout(() => {
            const fiexd = this.$refs.enterpriseBody
            const tabfixed = this.$refs.tabfixed
            fiexd.style.height = tabfixed.offsetHeight + 'px'
          }, 300)
        })
      }
    }
  },
  computed: {
    tabsNum1() {
      var num = 0
      if (this.componentTitles1.length) {
        num = (this.tabsNum + (this.componentTitles1[0].num || 1) + (this.componentTitles1[10] ? (this.componentTitles1[10].num || 0) : 0))
      }
      return num
    },
    // 字符串转数组
    regCapital() {
      if (this.companyStatus.amount === -1) {
        return '--'
      }
      if (this.companyStatus.registeredCapital && this.companyStatus.registeredCapital !== '0.0' && this.companyStatus.unit && this.companyStatus.currency) {
        return this.companyStatus.registeredCapital + this.companyStatus.unit + this.companyStatus.currency
      }
      return '--'
    },
    staffSize() {
      const staffSize = this.companyStatus.staffSize
      if (staffSize) {
        // if (staffSize.endsWith('人')) return staffSize
        if (staffSize.includes('人')) return staffSize
        return staffSize + '人'
      }
      return '--'
    },

    isUrls() {
      // console.log('======', this.companyStatus.websiteList);
      // 判断有无年报
      if (!this.companyStatus.websiteList) {
        return { status: 'null' }
      }
      if (this.companyStatus.websiteAnnualTag) {
        if (this.companyStatus.websiteList.includes(',')) {
          let arr = []
          let arr0 = []
          arr0 = this.companyStatus.websiteList.split(',').map(e => this.repliceHttps(e))
          arr0.forEach((v, index) => {
            this.companyStatus.websiteAnnualTag.split(',').forEach((v1, index1) => {
              if (index == index1) {
                arr.push({ v, v1 })
              }
            })
          })
          sortKey(arr, 'v1')
          this.companyStatus.websiteList = arr[0]['v']
          this.yearTime = arr[0]['v1']
          return { status: 'icon', string: this.companyStatus.websiteList }
        } else {
          this.yearTime = this.companyStatus.websiteAnnualTag
          if (!this.companyStatus.websiteList.includes('http://www.') && !this.companyStatus.websiteList.includes('https://www.')) {
            //  return { status: 'icon', string: 'http://' + this.companyStatus.websiteList }
            return { status: 'icon', string: 'http://www.' + this.companyStatus.websiteList.replace('http://', '').replace('www.', '').replace('https://', '') }
          } else {
            return { status: 'icon', string: this.companyStatus.websiteList }
          }
        }
      } else {
        if (this.companyStatus.websiteList.includes(',')) {
          let array = this.companyStatus.websiteList.split(',')
          array = array.map(e => this.repliceHttps(e))
          return { status: 'array', array }
        } else {
          if (!this.companyStatus.websiteList.includes('http://www.') && !this.companyStatus.websiteList.includes('https://www.')) {
            return { status: 'string', string: 'http://www.' + this.companyStatus.websiteList.replace('http://', '').replace('www.', '').replace('https://', '') }
          } else {
            return { status: 'string', string: this.companyStatus.websiteList }
          }
        }
      }

    },
    backgroundColor() {
      return this.bgColor[this.companyStatus.color]
    },
    companyTags() {
      if (this.companyStatus && this.companyStatus.tags) {
        return this.companyStatus.tags.split(',')
      }
      return []
    },
    companyIndustry() {
      if (this.companyStatus.bigIndustry) {
        const { bigIndustry, smallIndustry, thirdName, fourName } = this.companyStatus
        if (bigIndustry && smallIndustry && thirdName && fourName) {
          return `${bigIndustry}>${smallIndustry}>${thirdName}>${fourName}`
        }
        else if (bigIndustry && smallIndustry && thirdName) {
          return `${bigIndustry}>${smallIndustry}>${thirdName}`
        }
        else if (bigIndustry && smallIndustry) {
          return `${bigIndustry}>${smallIndustry}`
        }
        else if (bigIndustry) {
          return bigIndustry
        }
        return '--'
      }


      const { industry, subIndustry, thirdName, fourName } = this.companyStatus
      if (industry && subIndustry && thirdName && fourName) {
        return `${industry}>${subIndustry}>${thirdName}>${fourName}`
      }
      else if (industry && subIndustry && thirdName) {
        return `${industry}>${subIndustry}>${thirdName}`
      }
      else if (industry && subIndustry) {
        return `${industry}>${subIndustry}`
      }
      else if (industry) {
        return industry
      }
      return '--'
    }
  },
  filters: {
    formatTime(val) {
      if (val) {
        if (typeof val === 'string') val = val.replace(/-/ig, '/')
        return parseTime(new Date(val), '{y}-{m}-{d}')
      }
      return '--'
    }
  },
  mounted() {
    this.getData()
    const fiexd = this.$refs.enterpriseBody
    const tabfixed = this.$refs.tabfixed
    this.scrollbar = this.$refs.scrollbar.$el.querySelector('.el-scrollbar__wrap')

    //  fiexd.style.height = tabfixed.offsetHeight + 'px'
    this.scrollbar.addEventListener('scroll', e => {
      // 回显
      if (!this.isClick) {
        this.componentTitles.forEach((item, i) => {
          if (item.num > 0 && this.scrollbar.scrollTop >= document.querySelector('#bm' + item.label)?.offsetTop - fiexd.offsetHeight) {
            this.btnIndex = i
            this.componentTitles.forEach((tit, idx) => {
              if (this.btnIndex === idx) {
                tit.type = 'primary'
              } else {
                tit.type = ''
              }
            })
          }
        })
      }

      // 悬浮
      if (e.target.scrollTop >= fiexd.offsetTop) {
        this.fixed = true
      } else {
        this.fixed = false
      }
    })

    this.scrollbar.addEventListener('mousewheel', (e) => {
      this.isClick = false
    }, false)
  },

  methods: {
    // 复制公式ming
    copyName(val) {
      // var strs0 = document.getElementById('copyText').innerText
      var textBox = document.createElement('input')
      textBox.value = val
      document.body.appendChild(textBox)
      textBox.select()
      document.execCommand('Copy')
      textBox.className = 'textBox'
      textBox.style.display = 'none'
      // this.$message.success('复制成功')
      this.$message({
        type: 'success',
        message: '复制成功',
        duration: 2000
        // customClass: 'success-name'
      });
      document.body.removeChild(textBox)
    },
    // 更正子账户企业
    updateTrans(code) {
      if (code) {
        transactionDel({ id: this.componentInfo.transId }).then(res => {
          if (res.code === 200) {
            this.$message({
              message: '取消添加种子企业',
              type: 'success'
            });
            this.$refs['companyRefresh'].getCompanyInfo()
          }
        })
      } else {
        transactionAdd({ name: this.componentInfo.companyName }).then(res => {
          if (res.code === 200) {
            this.$message({
              message: '添加种子企业成功',
              type: 'success'
            });
            this.$refs['companyRefresh'].getCompanyInfo()
          }
        })
      }

    },
    // 更新数据
    setPcinfo(info) {
      this.componentInfo = info
      this.historyNameList = info.historyNameList //曾用名
    },
    getData() {
      this.basicInfo()
      this.companyBasicCountV2()
      // this.cxt()
      this.postVisitCompany()
    },
    getArr(str) {
      if (!str) return
      if (str) {
        return str[0].contactCount
      }
    },
    // 诚信通
    // cxt() {
    //   cxt({ companyName: this.companyStatus.companyName }).then(res => {
    //     this.cxtList = res.data || []
    //   })
    // },
    showMore() {
      this.showMoreA = true
    },
    replaceImgUrl(url) {
      if (url.indexOf('https') == -1) url = url.replace('http', 'https')
      return url
    },
    repliceHttps(str) {
      const urlP = /^http:\/\/.+/
      const ipv4AllRegex = /^https?:\/\/(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
      if (ipv4AllRegex.test(str)) {
        return str
      }
      const ipv4Regex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
      if (str.match(urlP)) {
        if (str.includes('www.')) {
          return str.replace('http://', 'https://')
        } else {
          return str.replace('http://', 'https://www.')
        }
      }
      if (!str.includes('http://www.') && !str.includes('https://www.')) {
        if (ipv4Regex.test(str)) {
          return 'http://' + str
        }
        return 'http://www.' + str
      }
      return str
    },
    computedNum1(num) {
      if (num > 999) {
        return '999+'
      }
      return num
    },
    // 埋点
    postVisitCompany() {
      const params = {
        companyName: this.companyStatus.companyName,
        hid: this.companyStatus.hid,
        logoPath: this.companyStatus.logoPath ? this.companyStatus.logoPath : null,
        alias: this.companyStatus.alias
      }
      visitCompany(params).then(res => {
        // console.log(res)
      }).catch(error => {
        console.log(error)
      })
    },
    computedNum2(num) {
      if (num > 99) {
        return '99+'
      }
      return num
    },
    tagsHandle(i) {
      this.btnIndex = i
      this.isClick = true
      this.componentTitles.forEach((e, ii) => {
        if (i === ii) {
          e.type = 'primary'
        } else {
          e.type = ''
        }
      })
      this.$refs.scrollbar.$el.querySelector('.el-scrollbar__wrap').scrollTop = document.querySelector('#bm' + this.componentTitles[i].label).offsetTop - this.$refs.enterpriseBody.offsetHeight
    },
    setTitles(titles) {
      if (this.activeName == 1) {
        this.componentTitles1 = titles
      }
      this.componentTitles = titles
    },
    handleClick(val) {
      if (this.tabFlag) {
        this.activeName = val
      } else {
        this.activeName = String(Number(val.index) + 1)
        if (val.index == this.tabNewsActive) return
      }
      this.companyDetailBatchV2()
      this.tabFlag = false
    },
    setLineHeight(val) {
      if (val && val.length > 0 && val.length < 3) {
        this.aliasLineHeight = true
      }
      const zz = /[\u4e00-\u9fa5]/g
      // if (val) return val.substr(0, 4)
      // return this.companyStatus.companyName.match(zz) && this.companyStatus.companyName.match(zz).join('').substr(0, 4)
      if (val) {
        return val.substr(0, 4)
      } else {
        if (this.companyStatus.companyName.match(zz)) {
          return this.companyStatus.companyName.match(zz).join('').substr(0, 4)
        } else {
          return this.companyStatus.companyName.substr(0, 4)
        }
      }
    },
    async companyBasicCountV2() {
      this.loading = true
      const companyName = this.companyStatus.companyName
      const hid = this.companyStatus.hid
      const { data } = await companyBasicCountV2({ companyName, hid })
      data.forEach(e => {
        this.tabs[this.mapIndex[e.moduleId]].children = e.children
        this.tabsNum = e.total
      })
      this.loading = false
    },

    async basicInfo() {
      let tabCardNumE = ''
      let smallCardNumE = ''
      if (window[X_HIDE] && window[X_isQw] == 1) {
        if (window[X_tabCardNum] && window[X_tabCardNum] != 'undefined') {
          tabCardNumE = window[X_tabCardNum]
          if ((window[X_smallCardNum] || window[X_smallCardNum] == 0) && window[X_smallCardNum] != 'undefined') {
            smallCardNumE = parseInt(window[X_smallCardNum])
          }
        }
      } else {
        if (this.$parent.$parent.$parent.tabCardNum) {
          tabCardNumE = this.$parent.$parent.$parent.tabCardNum
          if (this.$parent.$parent.$parent.smallCardNum || this.$parent.$parent.$parent.smallCardNum == 0) {
            smallCardNumE = this.$parent.$parent.$parent.smallCardNum
          }
        }
      }
      // 改变默认选中项
      if (tabCardNumE) {
        this.tabFlag = true

        setTimeout(() => {
          this.handleClick(tabCardNumE)
        }, 800)
        // 从企业列表标签进入详情
        if (smallCardNumE || smallCardNumE == 0) {
          setTimeout(() => {
            this.tagsHandle(smallCardNumE)
          }, 1000)
        }
      } else {
        this.tabFlag = false
      }

      this.loading = true
      const companyName = this.companyStatus.companyName
      const hid = this.companyStatus.hid
      const { data } = await companyCategoryCountV2({ companyName, hid })

      data.forEach(e => {
        if (e.name !== '基本信息') {
          this.tabs[this.mapIndex[e.moduleId]].num = e.total
          this.tabs[this.mapIndex[e.moduleId]].children = e.children
        }
      })
      const res = await getNews({ name: companyName, pageNum: 1, pageSize: 10 })
      if (res.data) { this.tabNewNum = res.data.total }

      let active = String(this.tabNewsActive)
      for (let i = 0; i < this.tabs.length; i++) {
        if (this.tabs[i].num > 0) {
          active = String(i + 1)
          break
        }
      }
      if (active == this.tabNewsActive) {
        this.loading = false
        return
      }
      this.activeName = active

      if (this.$parent.$parent.$parent.tabCardNum) {
        this.activeName = this.$parent.$parent.$parent.tabCardNum
      }

      this.loading = false
    },
    async companyDetailBatchV2(pageTurn) {
      this.loading = true
      const { companyName, hid } = this.companyStatus
      // 寻找映射关系
      let homeModuleId = null
      for (let key in this.mapIndex) {
        if (this.mapIndex[key] == (this.activeName - 1)) {
          homeModuleId = key
        }
      }
      const params = { companyName, hid, homeModuleId: Number(homeModuleId), pageSize: 10 }
      if (pageTurn) {
        params.moduleId = pageTurn.moduleId
        params.pageNum = pageTurn.pageNum
        const { isNew, currentPage, fieldData } = this.activeInfoMap[pageTurn.moduleId] || {}
        if (isNew) {
          if (params.pageNum > (currentPage || 1)) {
            params.lastRowKey = fieldData[fieldData.length - 1] && fieldData[fieldData.length - 1][0]
          } else {
            params.firstRowKey = fieldData[0] && fieldData[0][0]
          }
        }
        if (params.homeModuleId === 1) { // 基本信息
          var data = JSON.parse(JSON.stringify(params))
          data.homeModuleId = undefined
          getByPageV2(data).then(res => {
            if (this.activeInfo.findIndex(e => e.moduleId == res.data.moduleId) == -1) {
              this.activeInfo = this.activeInfo.concat(res.data)
              if (this.activeInfo.length) {
                this.activeInfo.forEach(x => {
                  this.$set(this.activeInfoMap, x.moduleId, x)
                  this.$set(this.activeInfoMap[x.moduleId], 'isNew', true)
                  this.$set(this.activeInfoMap[x.moduleId], 'fieldsMap', x.fields.reduce((p, n, i) => (p[n.fieldName] = { ...n, idx: i }, p), {}))
                  this.$set(this.activeInfoMap[x.moduleId], 'pageNum', x.currentPage)
                  this.$set(this.activeInfoMap[x.moduleId], 'currentPage', x.currentPage)
                })
              }
            }
            const list = JSON.parse(JSON.stringify(this.activeInfo))

            this.activeInfo.forEach((e, i) => {
              if (e.moduleId === pageTurn.moduleId) {
                e = res.data
                e.isNew = list[i].isNew
                e.pageNum = params.pageNum || e.currentPage
                e.fieldsMap = list[i].fieldsMap
                this.$set(this.activeInfo, i, e)
                this.activeInfoMap[e.moduleId] = e
                this.$refs.basicMsg.titles[pageTurn.index].pageNum = e.currentPage
              }
            })

          })
        } else {
          let [data, data1] = [[], []]
          !isNew && (data = (await companyDetailBatchV2(params)).data)
          isNew && (data1 = (await getByPageBatchV2(params)).data)
          data = data.concat(data1)
          this.activeInfo.forEach((e, i) => {
            if (e.moduleId == pageTurn.moduleId) {
              data[0].isNew = this.activeInfo[i].isNew
              data[0].pageNum && (data[0].currentPage = data[0].pageNum)
              data[0].fieldsMap = this.activeInfo[i].fieldsMap
              this.$set(this.activeInfo, i, data[0])
              this.activeInfoMap[e.moduleId] = data[0]
            }
          })
        }
      } else {
        if (params.homeModuleId === 1) { // 基本信息
          this.activeInfoMap = {}
          if (this.tabs[0] && this.tabs[0].children && this.tabs[0].children.length) {
            this.tabs[0].children.forEach(e => {
              getByPageV2({ companyName, hid, pageSize: 10, moduleId: e.moduleId, pageNum: 1 }).then(res => {
                if (res.data !== null && res.data.companyName) {
                  this.activeInfo = this.activeInfo.concat(res.data)
                  if (this.activeInfo.length) {
                    this.activeInfo.forEach(x => {
                      this.$set(this.activeInfoMap, x.moduleId, x)
                      this.$set(this.activeInfoMap[x.moduleId], 'isNew', true)
                      this.$set(this.activeInfoMap[x.moduleId], 'fieldsMap', x.fields.reduce((p, n, i) => (p[n.fieldName] = { ...n, idx: i }, p), {}))
                      this.$set(this.activeInfoMap[x.moduleId], 'pageNum', x.currentPage)
                      this.$set(this.activeInfoMap[x.moduleId], 'currentPage', x.currentPage)
                    })
                  }
                }
              })
            })
          }
        } else {
          this.activeInfoMap = {}
          const { data } = await companyDetailBatchV2(params)
          const { data: data1 } = await getByPageBatchV2(params)
          const dataMap = data.reduce((p, n, i) => (p[n.moduleId] = { ...n, idx: i }, p), {})
          this.activeInfoMap = data1.reduce((p, n) => {
            n.isNew = true
            n.fieldsMap = n.fields.reduce((p, n, i) => (p[n.fieldName] = { ...n, idx: i }, p), {})
            n.pageNum && (n.currentPage = n.pageNum)
            if (!dataMap[n.moduleId]) {
              data.push(n)
            } else {
              data[dataMap[n.moduleId].idx] = n
            }
            p[n.moduleId] = n
            return p
          }, dataMap)
          this.activeInfo = data
        }
      }
      this.loading = false
    }
  }
}
</script>
<style lang='scss' scoped>
.tagClass {
  color: #ab73ff;
  background: #f1edf9;
}

.tab {
  // height: 78px;
  padding: 0 32px;
  background: #ffffff;
  // background: #f0f2f5;
  .btn {
    display: inline-block;
    width: 110px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    color: #333333;
    font-size: 16px;
    background: #d8dee7;
    margin-top: 28px;
  }
  .btn + .btn {
    border-left: 2px #fff solid;
  }
  .is-select {
    background: #fff;
    color: #1890ff;
  }
}
.header {
  width: 100%;
  font-size: 12px;
  padding: 32px;
  padding-right: 24px;
  background-color: #fff;
  .logo2 {
    float: left;
    width: 58px;
    height: 58px;
    padding: 6px;
    background: rgba(80, 136, 255, 0.3);
    font-weight: 400;
    color: #fff;
    text-align: center;
    font-size: 21px;
    line-height: 24px;
    border-radius: 2px;
    margin-right: 24px;
  }
  .logo {
    float: left;
    width: 58px;
    height: 58px;
    // background: rgba(80, 136, 255, 0.3);
    border-radius: 2px;
    font-size: 0;
    // overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;

    margin-right: 24px;
    > img {
      width: 100%;
      object-fit: contain;
    }
  }
  .aliasLineHeight {
    line-height: 48px;
    overflow: hidden;
  }
  .hright {
    float: left;
    width: 566px;
  }
  h2 {
    font-size: 16px;
    font-weight: 400;
    display: flex;
    align-items: center;
    /deep/ .container {
      height: auto;
    }
  }
  .el-col-8 {
    // width: 265px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .el-col {
    > span {
      font-size: 12px;
    }
  }
}
.isurl {
  display: flex;

  a {
    display: block;
    // color: #4f7afd;
    color: #333333;
    line-height: 18px;
  }
  .more {
    font-size: 12px;
    float: right;
    margin-left: 10px;
    color: #4f7afd;
    cursor: pointer;
  }
}
.address {
  .addressTT {
    display: inline-block;
    width: calc(100% - 60px);
    vertical-align: top;
  }
}

.componentTags {
  padding: 15px 32px;
  padding-bottom: 4px;
  /deep/ .el-tag {
    cursor: pointer;
  }
  .el-button + .el-button {
    margin-left: 0;
  }
  .el-button {
    font-size: 12px !important;
    height: 24px;
    line-height: 24px;
    padding: 0 10px;
    /deep/ span {
      font-size: 12px;
    }
  }
}
.enterpriseBody {
  // background: #fff;
  .tabfixed {
    background: #fff;
    &.fixed {
      position: fixed;
      top: 15px;
      width: 100%;
      max-width: 716px;
      z-index: 9;
      box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 5px 0px;
    }
    // /deep/ .el-tabs__nav-prev {
    //   cursor: no-drop;
    //   &.is-disabled {
    //     cursor: pointer;
    //   }
    // }
    // /deep/ .el-tabs__nav-next {
    //   cursor: no-drop;
    //   &.is-disabled {
    //     cursor: pointer;
    //   }
    // }
  }
}
.content {
  padding: 24px;
  background-color: #fff;
}
.zd-zhongzhi {
  cursor: pointer;
  position: relative;
  left: -47px;
  top: 120px;
  img {
    width: 20px;
    height: 20px;
  }
}

.cls001 {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  line-height: 22px;
}
.cls002 {
  display: block;
}
.span01 {
  font-size: 13px !important;
  font-weight: 400;
  color: rgba(51, 51, 51, 0.5);
  line-height: 18px;
}
.span02 {
  font-size: 13px !important;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 18px;
}
/deep/ {
  .header h2 {
    display: flex;
    justify-content: space-between;
    .refresh-box {
      position: initial;
      .refresh-btn {
        font-size: 12px;
      }
      .refresh-tip {
        font-size: 13px;
        font-weight: 400;
        color: #999999;
        line-height: 18px;
        margin-left: 8px;
      }
    }
  }

  .cls-tabs-navs {
    .el-tabs__nav-next,
    .el-tabs__nav-prev {
      line-height: 24px;
      top: 24px;
      cursor: default;
      // font-size: 24px;
      // line-height: 13px;
      // color: #606266;
      i {
        font-size: 14px;
        line-height: 13px;
        color: #606266;
        font-weight: bold;
      }
    }
    .el-tabs__nav-prev {
      left: 32px;
      &.is-disabled {
        cursor: pointer;
      }
    }
    .el-tabs__nav-next {
      right: 32px;
      cursor: default;
      &.is-disabled {
        cursor: pointer;
      }
    }
    .el-tabs__item {
      // padding: 24px 0;
      .is-disabled {
        color: #333333;
      }
    }
    /deep/ .el-tabs__item.is-disabled {
      // color: #333333;
    }
    .el-tabs__nav-wrap.is-scrollable {
      // padding: 24px 32px;
      padding-top: 16px;
      padding-left: 60px;
      padding-right: 60px;
    }
  }

  .tab {
    .wrap {
      // padding: 12px 0;
    }
  }
}

.tags {
  .box {
    padding: 4px 12px;
    background: rgba(80, 136, 255, 0.15);
    border-radius: 2px;
    font-size: 12px;
    font-weight: 400;
    color: #5088ff;
    display: inline-flex;
    align-items: center;
    border: none;
    margin-right: 8px;
  }
  .box1 {
    background: rgba(48, 191, 120, 0.15);
    color: #30bf78;
  }
  .new-box1 {
    margin-bottom: 10px;
    &.hasBlue {
      color: #898bff;
      background: rgba(227, 242, 250, 1);
      border-color: #e2f2fa;
    }
  }
}

.popperClass {
  border: none;
  width: 66px;
  height: 24px;
  border-radius: 2px;
  background: rgba(52, 57, 81, 0.15);
  padding: 0;
  margin-right: 8px;
  span {
    font-weight: 400;
    color: #343951;
    font-size: 12px;
  }
}
.popperClass:hover {
  color: #343951;
}
.company-list {
  p {
    font-weight: 400;
    color: #666666;
    font-size: 13px;
    // line-height: 20px;
    // height: 20px;
    position: relative;
    padding-left: 11px;
    &::before {
      display: block;
      content: "";
      width: 5px;
      height: 5px;
      background: #666666;
      border-radius: 50%;
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      margin: auto;
    }
  }
}
.copyName {
  cursor: pointer;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
<style lang="scss">
.success-name {
  background: none;
  border: none;
}
.tpss {
  line-height: unset !important;
}
.cls-tabs-navs {
  &.newPosition {
    .el-tabs__item {
      transition: all 0.3s;
      border-bottom: 2px solid transparent;
      &.is-active {
        border-bottom: 2px solid #5088ff;
      }
    }
    .el-tabs__active-bar {
      display: none;
    }
  }
}
</style>
